/**
 *
 *
 */
export const defaultSkinThemes = [
  {
    componentCode: 'common',
    paramList: [
      { code: 'textColor', type: 1, value: '#267EF0' },
      { code: 'backgroundColor', type: 1, value: '#267EF0' },
      { code: 'activeBorderColor', type: 1, value: '#267EF0' },
      { code: 'activeBackgroundColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'tag',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#FFFFFF' },
      { code: 'textColor', type: 1, value: '#267EF0' },
      { code: 'borderColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'jump',
    paramList: [
      { code: 'textColor', type: 1, value: '#267EF0' },
      { code: 'iconColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'tabbar',
    paramList: [
      { code: 'activeTitleColor', type: 1, value: '#267EF0' },
      { code: 'activeIconColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'progress',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#267EF0' },
      { code: 'trackColor', type: 1, value: '#F7F7F7' },
    ],
  },
  { componentCode: 'dropdown', paramList: [{ code: 'textColor', type: 1, value: '#267EF0' }] },
  { componentCode: 'swipe', paramList: [{ code: 'backgroundColor', type: 1, value: '#267EF0' }] },
  {
    componentCode: 'translucenceCapsuleTabs',
    paramList: [
      { code: 'activeTitleColor', type: 1, value: '#267EF0' },
      { code: 'activeBorderColor', type: 1, value: '#267EF0' },
      { code: 'activeBackgroundColor', type: 1, value: '#267EF0' },
      { code: 'transparent', type: 3, value: '0.1' },
    ],
  },
  {
    componentCode: 'capsuleTabs',
    paramList: [
      { code: 'activeTitleColor', type: 1, value: '#FFFFFF' },
      { code: 'activeBorderColor', type: 1, value: '#267EF0' },
      { code: 'activeBackgroundColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'blackbodyTabs',
    paramList: [
      { code: 'activeTitleColor', type: 1, value: '#000000' },
      { code: 'activeLineColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'tabs',
    paramList: [
      { code: 'activeTitleColor', type: 1, value: '#267EF0' },
      { code: 'activeLineColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'outlineButton',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#FFFFFF' },
      { code: 'textColor', type: 1, value: '#267EF0' },
      { code: 'borderColor', type: 1, value: '#267EF0' },
    ],
  },
  {
    componentCode: 'footerButton',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#267EF0' },
      { code: 'textColor', type: 1, value: '#FFFFFF' },
    ],
  },
  {
    componentCode: 'secondaryButton',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#267EF0' },
      { code: 'textColor', type: 1, value: '#FFFFFF' },
      { code: 'borderColor', type: 1, value: '#267EF0' },
      { code: 'transparent', type: 3, value: '0.7' },
    ],
  },
  {
    componentCode: 'mainButton',
    paramList: [
      { code: 'backgroundColor', type: 1, value: '#267EF0' },
      { code: 'textColor', type: 1, value: '#FFFFFF' },
    ],
  },
];
